module.exports = __webpack_public_path__ + "static/media/47.e8306b4b.png";